import React, { useMemo, useContext } from 'react';
import { useOtherRoles } from './role-other-hook';
import {
  Table,
  TableHandle,
  useUpdateEffect,
  useEventCallback,
  DetailContext,
  DetailMode,
} from '@eas/common-web';
import { User, RoleInstance } from '../../../../models';
import { ExportTags } from '../../../../enums/export-tags';
import { ToolbarExportButton } from '../../../../components/evidence/history-evidence/overrides/toolbar-export-button';

export function OtherRoles({
  tableName = 'Přiřazené role',
  profile,
  useStyles,
  showReportButton = true,
}: {
  tableName?: string;
  profile: User;
  useStyles?: () => TableHandle<RoleInstance>['classes'];
  showReportButton?: boolean;
}) {
  const detailCtx = useContext(DetailContext);
  const { source, columns } = useOtherRoles(profile);

  const include = useMemo(() => ['DEACTIVATED'], []);

  const sorts = useMemo(
    () => [
      {
        field: 'active',
        datakey: 'active',
        order: 'DESC' as const,
        type: 'FIELD' as const,
      },
      {
        field: 'role.registeredFor.name',
        datakey: 'role.registeredFor.name',
        order: 'ASC' as const,
        type: 'FIELD' as const,
      },
      {
        field: 'validFrom',
        datakey: 'validFrom',
        order: 'DESC' as const,
        type: 'FIELD' as const,
      },
    ],
    []
  );

  const exportProvideData = useEventCallback(() => ({
    userId: profile.id,
  }));

  useUpdateEffect(() => {
    if (detailCtx?.mode === DetailMode.VIEW) {
      source.reset();
      source.loadMore();
    }
  }, [profile.id]);

  return (
    <Table
      version={4}
      tableId="ROLES_OTHER"
      tableName={tableName}
      columns={columns}
      source={source}
      height={300}
      showBulkActionButton={false}
      showSelectBox={false}
      showSearchbar={false}
      showReportButton={false}
      showResetSortsButton={true}
      reportTag={ExportTags.USER_ROLES_OTHER}
      exportProvideData={exportProvideData}
      defaultSorts={sorts}
      include={include}
      useStyles={useStyles}
      toolbarProps={{
        after: detailCtx?.mode === DetailMode.VIEW && showReportButton && (
          <ToolbarExportButton />
        ),
      }}
    />
  );
}
